import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {FeedbackFormLocationEnum} from '../../../../../shared/entity_datas/EntityDatas'
import {UIAjaxWrapper} from '../../network/UIAjaxWrapper'
import {UIAPIEndpoints} from '../../network/UIAPIEndpoints'
import {StorageWrapper} from '../../StorageWrapper'
import {ViewPopup} from '../ViewPopup'
import {ViewPopupFeedbackForm} from './ViewPopupFeedbackForm'
import {ViewPopupFeedbackFormText} from './ViewPopupFeedbackFormText'
import {FeedbackFormDataValidate} from '../../../../../shared/feedback_form/FeedbackFormDataValidate'
import {UIPopupController} from '../UIPopupController'
import {KeyBindController} from '../../KeyBindController'
import {uiGameManager} from '../../EntryShared'
import {GameStateEnums} from '../../../../../shared/GameEnums'

export const NO_OF_STARS = 5

export class UIFeedbackFormPopupController {
    private readonly feedbackFormPopups: ViewPopup[] = [
        new ViewPopupFeedbackForm(this),
        new ViewPopupFeedbackFormText(this),
    ]
    private previousPopup: ViewPopup | undefined

    private readonly finishAction: () => void

    formData: AjaxDataTypes.FeedbackFormData = {
        gameId: undefined,
        email: undefined,
        feedback: undefined,
        rate: undefined,
        skipped: true,
        location: FeedbackFormLocationEnum.Homepage,
    }

    constructor(finishAction: () => void, gameId: string | undefined, location: FeedbackFormLocationEnum) {
        this.finishAction = finishAction
        this.nextStep()
        this.formData.gameId = gameId
        this.formData.location = location
        StorageWrapper.setLastFeedbackFormDate(new Date())
    }

    nextStep(): void {
        const nextPopup = this.feedbackFormPopups.shift()

        if(this.previousPopup) {
            // Oct 24, 2023. Mau. We don't want to submit the form if the user is moving to the next step.
            this.previousPopup.removeAction = () => undefined
            this.previousPopup.removePopup()
        }

        const noMoreSteps = nextPopup == undefined
        if(noMoreSteps) {
            void this.submit()
            return
        }

        KeyBindController.instance.disableKeyBindings()
        nextPopup.show()
        nextPopup.removeAction = () => void this.submit()
        this.previousPopup = nextPopup
    }

    setFormData(formData: AjaxDataTypes.FeedbackFormData) {
        this.formData = formData
    }

    getRating(): number | undefined {
        return this.formData.rate
    }

    private async submit() {
        KeyBindController.instance.enableKeyBindings()

        if(!this.shouldSubmit()) {
            this.finishAction?.()
            return
        }

        try {
            FeedbackFormDataValidate.validate(this.formData)
        } catch(err) {
            const errorPopupCheckAction = () => {
                this.finishAction?.()
            }
            UIPopupController.create({key: 'strings:popups.errors.general.title'}, {key: 'strings:colonistCommon.utils.#buffer', options: {value: err.message}}, errorPopupCheckAction, errorPopupCheckAction, false, {showXButton: false})
            return
        }

        await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiFeedbackFormSubmit(), undefined, this.formData, 'application/json')
        uiGameManager.eventController.sendEvent(this.formData.rate, GameStateEnums.UIGameEventEnums.FeedbackFormSubmitted)
        this.finishAction?.()
    }

    private shouldSubmit(): boolean {
        if(this.formData.location != FeedbackFormLocationEnum.Homepage) return true
        if(!FeedbackFormDataValidate.isEmpty(this.formData)) return true
        return false
    }
}
